module.exports = __webpack_public_path__ + "static/media/landdroute.e0e90e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/landdroute.png
// module id = 1479
// module chunks = 0